import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { RootState } from 'store';

import { APPLICATION_STATE, FEATURE_FLAGS } from '../../constants';
import { EMPTY_ARRAY } from 'shared/constants';

export const useFeatureFlags = () => {
  const ƒeatureFlags = useSelector((state: RootState) => state[APPLICATION_STATE].featureFlags.data);
  return ƒeatureFlags;
};

export const useHasFeatureFlagFuelTask = () => {
  const featureFlags = useFeatureFlags() || EMPTY_ARRAY;

  const hasFeatureFlagFuelTask = useMemo(() => (
    featureFlags.find(item => item === FEATURE_FLAGS.fuelTasks)
  ), [featureFlags]);

  return hasFeatureFlagFuelTask;
};

export const useHasFeatureFlagPriceReport = () => {
  const featureFlags = useFeatureFlags() || EMPTY_ARRAY;

  const hasFeatureFlagPriceReport = useMemo(() => (
    featureFlags.find(item => item === FEATURE_FLAGS.priceReport)
  ), [featureFlags]);

  return hasFeatureFlagPriceReport;
};

const useFeatureFlagsLoadingStatus = () => {
  const featureFlagsLoadingStatus = useSelector((state: RootState) => state[APPLICATION_STATE].featureFlags.loadingStatus);
  return featureFlagsLoadingStatus;
};

export const useIsFeatureFlagsLoading = () => {
  const featureFlagsLoadingStatus = useFeatureFlagsLoadingStatus();
  return checkIsLoading(featureFlagsLoadingStatus);
};

export const useIsFeatureFlagsDone = () => {
  const featureFlagsLoadingStatus = useFeatureFlagsLoadingStatus();
  return checkIsLoadingDone(featureFlagsLoadingStatus);
};
